import { DocumentType } from '../../../types/document';
import { FILTER, MENU } from '../../../types/filters';
import { deprecatedPageEntity } from './internal';

/**
 * Normalizr schema representing the agenda
 */
export const Agenda = deprecatedPageEntity(DocumentType.AGENDA, {
  processStrategy: () => ({
    uid: DocumentType.AGENDA,
    type: DocumentType.AGENDA,
    filters: {
      [FILTER.MENU]: MENU.ACTIVITY,
    },
  }),
});
